import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
//import Select from "@material-ui/core/Select";
import Card from "@material-ui/core/Card";
//import MenuItem from "@material-ui/core/MenuItem";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import FilledInput from "@material-ui/core/FilledInput";
import FormLabel from "@material-ui/core/FormControl";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";

// @material-ui/icons components
import School from "@material-ui/icons/School";
//import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";

import { Typography } from "@material-ui/core";
// core components
//import AuthHeader from "components/Headers/AuthHeader.js";
//import componentStyles from "assets/theme/views/auth/register.js";
import componentStylesButtons from "assets/theme/components/button.js";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    // Add animation styles
    animation: `$sideUp 0.5s ease-out`,
    transform: "translateY(100%)",
    opacity: 0,
    animationFillMode: "forwards",
  },
  "@keyframes sideUp": {
    "0%": {
      transform: "translateY(100%)",
      opacity: 0,
    },
    "100%": {
      transform: "translateY(0)",
      opacity: 1,
    },
  },
  cardHeader: {
    textAlign: "center",
  },
  cardContent: {
    textAlign: "center",
  },
  buttonContainedInfo: {
    backgroundColor: theme.palette.info.main,
  },
}));

const useStylesButtons = makeStyles(componentStylesButtons);

function AddContent() {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const theme = useTheme();
  const history = useHistory();
  const location = useLocation(); // Use useLocation to access the state
  const { course_id, batch_id } = location.state || {}; // Access the state or provide a default value

  const [alertText, setalertText] = useState("");
  const [form, setform] = useState({
    link: "",
    code: "",
    starting_time: "",
    starting_date: "",
  });

  //text fields changes
  const handleChange = (e) => {
    setalertText("");
    setform((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const ChangeCLick = () => {
    if (
      ["link", "code", "starting_time", "starting_date"].some(
        (field) => form[field] === ""
      )
    ) {
      setalertText("please fill all the fields");
      return;
    }
    
    var token = localStorage.getItem("token");

    const fetchAdd = async () => {
      try {
        const res = await fetch(
          "https://server.thelanofficial.com/Add-Session",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              link: form.link,
              code: form.code,
              starting_time: form.starting_time,
              starting_date: form.starting_date,
              batch_id: batch_id,
              token,
            }),
          }
        );

        if (!res.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await res.json();

        if (data.valid === false) {
          setalertText(data.message);
        } else if (data.valid === true) {
          setform((prev) => ({
            ...prev,
            [form.password]: "",
          }));
          setalertText(data.message);
        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    };

    fetchAdd();
  };

  useEffect(() => {
    var token = localStorage.getItem("token");
   
    const fetchData = async () => {
      try {
        const res = await fetch(
          "https://server.thelanofficial.com/validate-token",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ token }),
          }
        );

        if (!res.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await res.json();
        if (data.valid === false) {
          history.push("/auth/login");
        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Box component={Grid} container justifyContent="center">
        <Grid item xs={12} lg={6} md={8}>
          <Card classes={{ root: classes.cardRoot }}>
            <CardHeader
              className={classes.cardHeader}
              title={
                <Box
                  fontSize="200%"
                  fontWeight="800"
                  component="large"
                  color={theme.palette.gray[600]}
                >
                  ADD SESSION LINK
                </Box>
              }
              titleTypographyProps={{
                component: Box,
                textAlign: "center",
                marginBottom: "1rem!important",
                marginTop: ".5rem!important",
                fontSize: "1rem!important",
              }}
            ></CardHeader>
            <CardContent classes={{ root: classes.cardContent }}>
              <Box
                color={theme.palette.gray[600]}
                textAlign="center"
                marginBottom="1.5rem"
                marginTop=".5rem"
                fontSize="1rem"
              >
                <Box fontSize="80%" fontWeight="400" component="small">
                  fill in the relative fields
                </Box>
              </Box>
              <Box style={{ display: "flex", direction: "col", gap: "5px" }}>
                <FormControl
                  variant="filled"
                  component={Box}
                  width="100%"
                  marginBottom="1.5rem!important"
                >
                  <FilledInput
                    autoComplete="off"
                    type="text"
                    name="link"
                    value={form.link}
                    onChange={handleChange}
                    placeholder="Paste link"
                    startAdornment={
                      <InputAdornment position="start">
                        <School />
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl
                  variant="filled"
                  component={Box}
                  width="100%"
                  marginBottom="1.5rem!important"
                >
                  <FilledInput
                    autoComplete="off"
                    type="text"
                    name="code"
                    value={form.code}
                    onChange={handleChange}
                    placeholder="code for the meeting"
                    startAdornment={
                      <InputAdornment position="start">
                        <School />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Box>

              <Grid
                container
                component={Box}
                alignItems="center"
                marginBottom="1.5rem"
              >
                <Grid item xs={12} md={2}>
                  <FormLabel component={Box} marginBottom="0!important">
                    Time
                  </FormLabel>
                </Grid>
                <Grid item xs={12} md={10}>
                  <OutlinedInput
                    fullWidth
                    type="time"
                    onChange={handleChange}
                    name="starting_time"
                    defaultValue="10:30:00"
                  />
                </Grid>
              </Grid>

              <Grid
                  container
                  component={Box}
                  alignItems="center"
                  marginBottom="1.5rem"
                >
                  <Grid item xs={12} md={2}>
                    <FormLabel component={Box} marginBottom="0!important">
                      Date
                    </FormLabel>
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <OutlinedInput
                      fullWidth
                      type="date"
                      onChange={handleChange}
                      name="starting_date"
                      defaultValue="2021-11-23"
                    />
                  </Grid>
                </Grid>

              <Box
                fontStyle="italic"
                fontSize="1rem"
                color={theme.palette.gray[600]}
                marginBottom=".5rem"
              >
                <Box component="small" fontSize="80%">
                  <Box
                    component="span"
                    fontWeight="700"
                    color={theme.palette.success.main}
                  ></Box>
                </Box>
              </Box>

              <Typography
                style={{
                  color:
                    alertText === "Session link successfully added"
                      ? "green"
                      : "red",
                  fontSize: "10px",
                }}
              >
                {alertText}
              </Typography>

              <Box textAlign="center" marginTop="1.5rem" marginBottom="1.5rem">
                <Button
                  onClick={ChangeCLick}
                  variant="contained"
                  classes={{ root: classes.buttonContainedInfo }}
                >
                  Add Session
                </Button>
              </Box>
            </CardContent>
          </Card>
          <Grid container component={Box} marginTop="1rem">
            <Grid item xs={6} component={Box} textAlign="left"></Grid>
            <Grid item xs={6} component={Box} textAlign="right"></Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default AddContent;
